export default function TableButtonsArea({children}) {
    return <div className="ml-auto flex text-tm-gray-700 space-x-1.5">
        {children}
    </div>
}